module.exports = __webpack_public_path__ + "img/maestro-logo.dced8be9.svg";